import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import { Landing } from './components/Landing/Landing';
import { Home } from './components/Home/Home';
import { Detail } from './components/Detail/Detail';
import { CreateActivity } from './components/CreateActivity/CreateActivity';
import { Activities } from './components/AllActivities/Activities';
import { EditActivity } from './components/EditActivity/EditActivity';

function App() {
  return (
    <div>
      <BrowserRouter>
        <Route exact path={'/'} component={Landing} />
        <Route exact path={'/home'} component={Home} />
        <Route exact path={'/country/:id'} component={Detail} />
        <Route exact path={'/create-activity'} component={CreateActivity} />
        <Route exact path={'/activities'} component={Activities} />
        <Route exact path={'/edit-activity/:id'} component={EditActivity} />
      </BrowserRouter>
    </div>
  );
}

export default App;
